module.exports = __webpack_public_path__ + "static/media/app_activation.7317e33f.webp";